"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_StructureMap_Rule = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_id_1 = require("../Scalar/RTTI_id");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_StructureMap_Source_1 = require("./RTTI_StructureMap_Source");
var RTTI_StructureMap_Target_1 = require("./RTTI_StructureMap_Target");
var RTTI_StructureMap_Dependent_1 = require("./RTTI_StructureMap_Dependent");
exports.RTTI_StructureMap_Rule = t.recursion('IStructureMap_Rule', function () {
    return t.intersection([
        t.type({
            source: t.array(RTTI_StructureMap_Source_1.RTTI_StructureMap_Source)
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            name: RTTI_id_1.RTTI_id,
            _name: RTTI_Element_1.RTTI_Element,
            target: t.array(RTTI_StructureMap_Target_1.RTTI_StructureMap_Target),
            rule: t.array(exports.RTTI_StructureMap_Rule),
            dependent: t.array(RTTI_StructureMap_Dependent_1.RTTI_StructureMap_Dependent),
            documentation: t.string,
            _documentation: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_StructureMap_Rule.js.map